// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Pim6","col":"styles_col__2KsnZ","fulfillmentStatus":"styles_fulfillmentStatus__3wGbR","emailCol":"styles_emailCol__ozDe5"};